<xm-medication-widget-view
  [items]="medicationItems()"
  [title]="title"
  [searchFn]="searchMedication$"
  [canAdd]="canAdd()"
  [canDelete]="canDelete()"
  [isProcessing]="isProcessing()"
  (itemAdded)="onItemSelected($event.item)"
  (itemRemoved)="onItemRemoved($event)"
  (addNewItem)="onAddNewItem($event)">

  @if (canSaveScript() && hasMedication) {
    <button
      widget-footer
      mat-flat-button
      color="primary"
      class="w-100"
      xuiConfirmationDialog
      [confirmMessage]="confirmationMessage"
      (confirm)="saveScript()">
      Save Script
    </button>
  }
</xm-medication-widget-view>
